import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fontsArmin.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/armingrotesk-regular-webfont.woff2%22,%22style%22:%22normal%22,%22weight%22:%22400%22},{%22path%22:%22./fonts/armingrotesk-semibold-webfont.woff2%22,%22style%22:%22normal%22,%22weight%22:%22600%22},{%22path%22:%22./fonts/armingrotesk-ultrabold-webfont.woff2%22,%22style%22:%22normal%22,%22weight%22:%22800%22}],%22display%22:%22fallback%22,%22variable%22:%22--font-armin%22,%22declarations%22:[{%22prop%22:%22ascent-override%22,%22value%22:%2290%%22}]}],%22variableName%22:%22arminFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'arminFont', 'arminFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
